import $ from 'jquery';


/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

function storeValue () {
  return this.each( function () {
    const $target = $( this );
    const $areChecked = $target.is( 'input[type="radio"]:checked' ) || $target.is( 'input[type="checkbox"]:checked' );
    const $areNotButtons = $target.is( ':not(input[type="radio"])' ) && $target.is( ':not(input[type="checkbox"])' );
    const key = $target.data( 'store-value' );
    let value;
    if ( $areChecked || $areNotButtons ) {
      value = $target.val();
    }
    if ( typeof key === 'string' ) {
      if ( value ) {
        localStorage.setItem( key, value );
        $target.trigger('stored.value');
      } else if ( $areNotButtons && localStorage.getItem( key ) ) {
        $target.val( localStorage.getItem( key ) ).trigger('restored.value');
      }
    }
  } );
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

$( document ).on( 'change', '[data-store-value]', function ( e ) {
  $( e.target ).storeValue();
} );

$( function ( $ ) {
  $( '[data-store-value]' ).storeValue();
} );

$.fn.storeValue = storeValue;